import Axios from '../axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { deserialize, serialize } from '../utility/serialization'
import { handleAPIError } from '../utility/actionHelper'

// THUNKS

export const updateEnrollment = createAsyncThunk(
  'enrollment/updateEnrollment',
  async ({ enrollmentData, coachMessage }, { rejectWithValue }) => {
    try {
      const { data } = await requestUpdateEnrollment(enrollmentData, coachMessage)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const deleteEnrollment = createAsyncThunk(
  'enrollment/deleteEnrollment',
  async ({ enrollmentId, refund, coachMessage, notifyViaEmail }, { rejectWithValue }) => {
    try {
      const { data } = await requestDeleteEnrollment(enrollmentId, refund, coachMessage, notifyViaEmail)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const addProgramEnrollmentsManually = createAsyncThunk(
  'enrollment/addEnrollmentsManually',
  async ({ programId, userIds, message }, { rejectWithValue }) => {
    try {
      const { data } = await requestPostProgramEnrollments(userIds, programId, message)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

// API CALLS

const requestPostProgramEnrollments = (userIds, programId, message) => {
  const requestUrl = `/api/v1/courses/${programId}/enrollments`

  return Axios.post(requestUrl, serialize({ userIds, coachMessage: message }))
}

function requestUpdateEnrollment(enrollment, coachMessage = '') {
  const requestUrl = `/api/v1/enrollments/${enrollment.id}`

  return Axios.patch(requestUrl, { ...serialize(enrollment), coach_message: coachMessage })
}

function requestDeleteEnrollment(enrollmentId, refund, coachMessage = '', notifyViaEmail = false) {
  const requestUrl = `/api/v1/enrollments/${enrollmentId}`

  return Axios.delete(requestUrl, { params: { refund, coach_message: coachMessage, send_email: notifyViaEmail } })
}

export const requestGetEnrollmentsExist = (communityId) => {
  const requestUrl = `/api/v1/communities/${communityId}/enrollments/exist`

  return Axios.get(requestUrl)
}
